<div class="container-wrapper">
	<label [ngClass]="{'invalid': showRequiredIndication&& !selectedObj}">{{'Icon'|cpLabelTranslate}}</label>
	<div class="icon-and-selection-container">
		<div class="cp-icon-color-1 external-icon" *ngIf="selectedIconClassOrKey">
			<i [class]="selectedObj?.icon"></i>
		</div>
		<div class="icon-wrapper">
			<div [ngClass]="{hidden:readOnly,'error': showRequiredIndication&& !selectedObj}" class="combo-wrapper">
				<kendo-combobox #list [data]="icons$|async"
								(click)="openComboBox($event,list)"
								(valueChange)="selectIcon($event)"
								[valueField]="selectionProperty"
								[textField]="'name'"
								[value]="selectedObj"
								[filterable]="true"
								[popupSettings]="{width: 'auto'}"
								>
					<ng-template kendoAutoCompleteItemTemplate let-icon>
						<cp-icon-text-row [text]="icon.name" [iconClass]="icon.icon"></cp-icon-text-row>
<!--								<span class="cp-icon-color-1">-->
<!--									<i [class]="icon.icon"></i>-->
<!--								</span>-->
<!--						{{ icon.name }}-->
					</ng-template>
				</kendo-combobox>
			</div>
			<div [ngClass]="{hidden:!readOnly}">
				{{ selectedObj?.name }}
			</div>
		</div>
	</div>
</div>

